<template>
  <div>
    <div class="flex-row" style="width: 100%" v-mobile.hide>
      <div class="combo-vol m-r-10">
        <bookVolumes
          :tabId="tabId"
          v-if="tabData(tabId).volumes.length > 1"
          :books="tabData(tabId).volumes"
        />
      </div>
      <div
        class="search search-in-book flex"
        v-if="!customBook"
        :class="{
          'mobile-search': $_mobile,
          'small-search': !isWide,
          'float-search': showSmallSearchInput && !isWide,
        }"
      >
        <baseInputIconSearch
          style="padding-right: 3px"
          class="w-100"
          :placeholder="
            searchCurrentPage
              ? $t('freeSearchInput.searchInCurrentPage')
              : $t('freeSearchInput.placeHolderInBook')
          "
          @input="setTextSearch"
          :text="searchInBookTxt"
          @search="search"
          @clear="$store.state.freeSearch.searchInBookTxt = ''"
          :nofocus="true"
          :searchCurrentPage="searchCurrentPage"
          ref="searchInput"
        >
          <div
            v-if="true"
            class="search-btns-container"
            @click="$refs.searchInput.setFocus()"
          >
            <div
              class="search-in-page-btn"
              :class="{ active: searchCurrentPage }"
              v-tooltip="$t('freeSearchInput.searchInCurrentPage')"
              @click="searchCurrentPage = true"
            >
              <Icons icon="search-in-page" height="12px" width="12px" />
            </div>
            <div
              class="search-in-book-btn"
              :class="{ active: !searchCurrentPage }"
              v-tooltip="$t('freeSearchInput.searchInAllBook')"
              @click="searchCurrentPage = false"
            >
              <Icons icon="search-in-book" height="12px" width="12px" />
            </div>
          </div>
        </baseInputIconSearch>
      </div>
      <div
        :class="{ 'small-search': !isWide }"
        class="icon-general icon-search"
        @click="showSearch"
      >
        d
      </div>
    </div>
    <!-- not delete this div!!! -->
    <div class=""></div>
    <pagePicker
      :tabId="tabId"
      v-if="
        false &&
        !$_mobile &&
        $store.state.tabs[this.tabId].SHAS_SECTION_LIST_ID &&
        !tabId.startsWith('win_')
      "
    />
    <pagesArrows
      v-if="false && numPages > 0 && !txtBook"
      :numPages="numPages"
      :page="page"
      :tabId="tabId"
    />

    <pagesNavigator
      v-if="numPages > 0 && !txtBook"
      :numPages="numPages"
      :page="page"
      :tabId="tabId"
    />
    <txtPagesNavigator
      v-if="numPages > 0 && txtBook"
      :numPages="numPages"
      :page="page"
      :tabId="tabId"
    />

    <customText
      class="dir-l"
      @font-family="changeF"
      @font-size="changeS"
      v-if="txtBook"
    />
  </div>
</template>
<script>
import mixFreeSearch from "@/mixing/mixFreeSearch";
import { setSearchType } from "@/services/freeSearch.js";
import pagesArrows from "@/components/book/pagesArrows.vue";
import pagesNavigator from "@/components/book/pagesNavigator.vue";
import txtPagesNavigator from "@/components/book/txtPagesNavigator.vue";
import customText from "@/components/book/customText.vue";
import bookVolumes from "@/components/book/bookVolumes.vue";
import pagePicker from "@/components/mefPagePicker/PagePickerContainer.vue";
import Icons from "@/components/Icons/Icons.vue";
import { createFreeSearchBookListStore } from "@/store_pinia";

export default {
  data() {
    return {
      searchCurrentPage: false,
      widthThreshold: 600,
      isWide: true,
      showSmallSearchInput: false,
    };
  },
  mixins: [mixFreeSearch],
  props: ["hasTabs", "numPages", "page", "tabId", "book"],
  components: {
    pagesArrows,
    pagesNavigator,
    pagePicker,
    customText,
    bookVolumes,
    Icons,
    txtPagesNavigator,
  },
  watch: {
    splitterChange: function (val, oval) {
      this.checkWidth();
    },
  },
  computed: {
    freeSearchBookListStore() {
      return createFreeSearchBookListStore("main");
    },
    splitterChange() {
      return this.$store.state["tabsManager"].splitterChange;
    },
    customBook() {
      return this.otzarBook.type(this.book) == "custom";
    },
    txtBook() {
      return this.$store.state.tabs[this.tabId].txtBook;
    },
    searchInBookTxt() {
      return this.$store.state.freeSearch.searchInBookTxt;
    },
  },
  methods: {
    showSearch() {
      this.showSmallSearchInput = !this.showSmallSearchInput;
    },
    checkWidth() {
      const divWidth = this.$el.offsetWidth;
      this.isWide = divWidth >= this.widthThreshold;
    },
    setTextSearch(e) {
      let txt = "";
      try {
        txt = e.target.value.replace(/\s\s$/g, "-");
      } catch (ex) {
        txt = e.replace(/\s\s/g, "-");
      }
      this.$store.state.freeSearch.searchInBookTxt = txt;
    },
    search() {
      this.$store.state.freeSearch.inBook = true;
      if (this.searchInBookTxt != "") {
        this.$emit("search", {
          show: true,
          txt: this.searchInBookTxt,
        });
        setSearchType("classic");
        let books = [this.book];

        if (this.searchCurrentPage) {
          let pages = this.$store.state.tabs[this.tabId].pages;
          let currPage = pages.find((p) => p.position == this.page);
          if (currPage) {
            let { firstWord, numWords } = currPage.pagedata[0];
            books = {
              positions: `${firstWord}-${firstWord + numWords}`,
              book: this.book,
              id: this.page,
              currentPage: true,
            };
          }
        }
        this.doFreeSearch(
          this.searchInBookTxt.replace(/[\u0591-\u05C7]/g, ""), //remove niqud,
          books,
          0,
          true,
          this.tabId
        ).then(() => {
          this.$emit("search", {
            show: false,
            txt: this.searchInBookTxt,
          });
        });
      }
    },
    changeF(font) {
      this.$emit("font-family", font);
    },
    changeS(size) {
      this.$emit("font-size", size);
    },
    tabData(tabId) {
      return this.$store.state.tabs[tabId];
    },
  },
  mounted() {
    window.addEventListener("resize", this.checkWidth);
    this.checkWidth();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkWidth);
  },
};
</script>
<style scoped lang="scss">
.m-r-10 {
  margin-right: 10px;
}
.combo-vol {
  // position: absolute;
}
.search {
  max-width: 350px;
  width: 100%;
}
.mobile-search {
  max-width: 30% !important;
}
.small-search.icon-search {
  display: block !important;
}
.small-search.search-in-book {
  display: none;
}
.float-search {
  display: block !important;
  right: 46px;
  top: 2px;
  position: absolute;
}
.search-in-book {
  margin-bottom: 4px;
}
.page-icon {
  width: 25px;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 5px;
}
.btn-header-book {
  height: 100%;
  align-items: center;
  display: flex;
  margin: 0px 0px;

  &:hover {
    stroke: gray !important;
    fill: gray !important;
  }
}
.icon-search {
  display: none;
  cursor: pointer;
  &:hover {
    background-color: lightblue;
  }
}
.search-btns-container {
  width: 45px;
  height: 24px;
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 4px;
  top: 1px;
}
.search-in-book-btn {
  display: flex;
  width: 22px;
  height: 22px;
  padding: 5px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 3px;
  background: #e4e2e2;
  cursor: pointer;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.15);
  svg {
    fill: #c0c0c0;
  }
}
.search-in-book-btn.active {
  background: #fff;
  svg {
    fill: var(--custom-color1) !important;
  }
}
.search-in-page-btn {
  display: flex;
  width: 22px;
  height: 22px;
  padding: 5px 5px 3px 5px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 3px;
  background: #e4e2e2;
  cursor: pointer;
  svg {
    fill: #c0c0c0;
  }
}
.search-in-page-btn.active {
  background: #fff;
  svg {
    fill: var(--custom-color1) !important;
  }
}
</style>
